export const DOMAINS_RESET_STATE = 'DOMAINS_RESET_STATE';
export const DOMAINS_CURRENT_ITEM = 'DOMAINS_CURRENT_ITEM';

export const DOMAINS_REQUEST_LOADING = 'DOMAINS_REQUEST_LOADING';
export const DOMAINS_REQUEST_SUCCESS = 'DOMAINS_REQUEST_SUCCESS';
export const DOMAINS_REQUEST_FAILED = 'DOMAINS_REQUEST_FAILED';

export const DOMAINS_CURRENT_ACTION = 'DOMAINS_CURRENT_ACTION';
export const DOMAINS_RESET_ACTION = 'DOMAINS_RESET_ACTION';